import React from "react";
import { useNavigate } from "react-router-dom";
import "./ChooseTask.css";
import search from "../../../assets/search.png";

const ChooseTask: React.FC = () => {
  const navigate = useNavigate();

  const handleStartTest = () => {
    navigate("/task-info");
  };

  return (
    <div role="main">
      <div className="title"></div>
      <div className="title22">
        <div>Система проведения аккредитации специалистов</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="content-test">
        <div
          onClick={() => {
            localStorage.clear();

            navigate("/");
          }}
          className="gohome"
        >
          Выход
        </div>
        <div className="container">
          <p className="test-name" onClick={handleStartTest}>
            [1] Решение ситуационных задач - 3-й этап (Мультикейсы)
          </p>
        </div>
        <div className="btn-cont">
          <button className="button">Все курсы</button>
        </div>
      </div>
    </div>
  );
};

export default ChooseTask;
